export const PUBLIC_SITE = {
  companyName: "MANTRAL UG (haftungsbeschränkt)",
  street: "Am Lindenbaum 11",
  postalCode: "53639",
  city: "Königswinter",
  country: "Deutschland",
  managingDirector: "Nadja Danielle Sophie Kitz",
  registerCourt: "Amtsgericht Siegburg",
  registerNumber: "HRB 19664",
  email: "info@mantral.app",
  website: "https://mantral.app",
} as const;

export const PUBLIC_CONTACT_HREF = `mailto:${PUBLIC_SITE.email}`;

const BOOKING_PROVIDER_HOSTS = ["cal.com", "calendly.com"] as const;

// Google steht getrennt, weil dort zusaetzlich der Pfad zaehlt: calendar.google.com
// liefert unter /calendar/u/0/... auch die private Kalenderoberflaeche. Einbettbar
// sind nur die Terminseiten (Appointment Schedules) unter /calendar/appointments/.
const GOOGLE_BOOKING_HOST = "calendar.google.com";
const GOOGLE_BOOKING_PATH_PREFIX = "/calendar/appointments/";

function normalizeHost(hostname: string): string {
  return hostname.replace(/^www\./, "").toLowerCase();
}

function isSupportedBookingHost(hostname: string): boolean {
  const normalized = normalizeHost(hostname);
  return BOOKING_PROVIDER_HOSTS.some(
    (provider) => normalized === provider || normalized.endsWith(`.${provider}`),
  );
}

function safeBookingUrl(rawValue: unknown): string | null {
  if (typeof rawValue !== "string" || !rawValue.trim()) return null;

  try {
    const url = new URL(rawValue.trim());
    if (url.protocol !== "https:") return null;

    if (normalizeHost(url.hostname) === GOOGLE_BOOKING_HOST) {
      return url.pathname.startsWith(GOOGLE_BOOKING_PATH_PREFIX)
        ? url.toString()
        : null;
    }

    return isSupportedBookingHost(url.hostname) ? url.toString() : null;
  } catch {
    return null;
  }
}

export const PUBLIC_BOOKING_URL = safeBookingUrl(
  import.meta.env.VITE_PUBLIC_BOOKING_URL,
);

export function getBookingProviderLabel(url: string): string {
  try {
    const hostname = new URL(url).hostname.replace(/^www\./, "");
    if (hostname === "cal.com" || hostname.endsWith(".cal.com")) return "Cal.com";
    if (hostname === "calendly.com" || hostname.endsWith(".calendly.com")) {
      return "Calendly";
    }
    // Produktname statt "Google Kalender", damit der Wert wie die beiden anderen
    // Labels in DE und EN gleich funktioniert (er wird in {{provider}} interpoliert).
    if (hostname === GOOGLE_BOOKING_HOST) return "Google Calendar";
    return hostname;
  } catch {
    return "externen Kalenderanbieter";
  }
}
